import React from 'react';
import EmployeesHeader from "../Headers/EmployeesHeader";
import {employeesTest} from "../../../helpers/employees-test";
import PersonaInfromationData from "../Panels/PersonaInfromationData";
import PaymentDataPanel from "../Panels/PaymentDataPanel";
import SocialSecurityPanel from "../Panels/SocialSecurityPanel";
import ContractPanel from "../Panels/ContractPanel";
import RetentionPanel from "../Panels/RetentionPanel";

const EmployeeInformationGrid = () => {
  return (
    <>
      <div className="lg-cols-2">
        <EmployeesHeader employee={employeesTest[1]}/>
      </div>

      <div>
        <div className="ed-grid row-gap">
          <PersonaInfromationData/>
          <PaymentDataPanel/>
          <SocialSecurityPanel/>
        </div>
      </div>

      <div>
        <div className="ed-grid row-gap">
          <ContractPanel/>
          <RetentionPanel/>
        </div>
      </div>
    </>
  );
};

export default EmployeeInformationGrid;
